import React, { useEffect, useState } from 'react';
import { Sparkles, Loader2, AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import { adminAPI } from '../services/api';

// Admin › Produits : bulk AI writing of the full SEO block (H1/title/meta/keywords/structured description/FAQ) + translations
export const ProductsSeoBulk = ({ onDone }) => {
  const [status, setStatus] = useState(null);
  const [starting, setStarting] = useState(false);
  const [overwrite, setOverwrite] = useState(false);
  const [onlyCd, setOnlyCd] = useState(true);
  const [wasRunning, setWasRunning] = useState(false);

  const load = () => adminAPI.generateSeoStatus().then(setStatus).catch(() => {});
  useEffect(() => {
    load();
    const id = setInterval(load, status?.job?.running ? 3000 : 15000);
    return () => clearInterval(id);
  }, [status?.job?.running]);
  useEffect(() => {
    if (status?.job?.running) setWasRunning(true);
    else if (wasRunning) { setWasRunning(false); onDone?.(); }
  }, [status?.job?.running]); // eslint-disable-line react-hooks/exhaustive-deps

  const start = async () => {
    setStarting(true);
    try { const r = await adminAPI.generateSeoBulk(overwrite, onlyCd); toast[r.started ? 'success' : 'info'](r.message); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Lancement impossible'); }
    finally { setStarting(false); }
  };

  if (!status) return null;
  const job = status.job || {};
  const pct = job.total ? Math.round((job.processed / job.total) * 100) : 0;
  const target = onlyCd ? (overwrite ? status.cd_total : status.cd_missing) : (overwrite ? status.total : status.missing);
  return (
    <div className="border border-violet-200 bg-violet-50/40 rounded-lg p-3 text-sm" data-testid="products-seo-bulk">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex-1 min-w-[220px]">
          <p className="font-semibold text-gray-800 flex items-center gap-1"><Sparkles size={14} className="text-violet-600" /> Fiches SEO complètes (IA)</p>
          <p className="text-xs text-gray-500">H1, titre, méta, mots-clés, description structurée (H2), FAQ, 4 langues — faits de la fiche uniquement, unicité contrôlée. {status.missing} fiche(s) sans bloc SEO sur {status.total}.</p>
        </div>
        <label className="inline-flex items-center gap-1 text-xs text-gray-700"><input type="checkbox" checked={onlyCd} onChange={(e) => setOnlyCd(e.target.checked)} data-testid="products-seo-bulk-cd" /> Notes C/D seulement</label>
        <label className="inline-flex items-center gap-1 text-xs text-gray-700"><input type="checkbox" checked={overwrite} onChange={(e) => setOverwrite(e.target.checked)} data-testid="products-seo-bulk-overwrite" /> Réécrire aussi les fiches déjà remplies</label>
        <button type="button" onClick={start} disabled={starting || job.running || !target} className="inline-flex items-center gap-1 text-xs font-medium text-white bg-violet-600 hover:bg-violet-700 disabled:opacity-60 rounded-md px-3 py-1.5" data-testid="products-seo-bulk-start">
          {starting || job.running ? <Loader2 size={12} className="animate-spin" /> : <Sparkles size={12} />} {job.running ? 'En cours…' : `Rédiger ${target} fiche(s)`}
        </button>
      </div>
      {job.running && (
        <div className="mt-2" data-testid="products-seo-bulk-progress">
          <div className="h-2 bg-white rounded overflow-hidden border"><div className="h-full bg-violet-500 transition-all" style={{ width: `${pct}%` }} /></div>
          <p className="text-xs text-gray-600 mt-1">{job.processed}/{job.total} · {job.detail}</p>
        </div>
      )}
      {!job.running && job.finished_at && (
        <div className="mt-2 text-xs text-gray-700" data-testid="products-seo-bulk-result">
          Dernier lot : {job.done}/{job.total} fiche(s) rédigée(s) · {(job.errors || []).length} erreur(s)
          {job.flagged?.length > 0 && <span className="inline-flex items-center gap-1 text-amber-700 ml-2"><AlertTriangle size={12} /> {job.flagged.length} à relire : {job.flagged.slice(0, 3).map(f => f.name).join(', ')}{job.flagged.length > 3 ? '…' : ''}</span>}
        </div>
      )}
    </div>
  );
};

export default ProductsSeoBulk;
